import { Button, Rate } from 'antd';
import styled from 'styled-components';

export const StyledFloatButton = styled(Button)`
  position: fixed;
  bottom: 1%;
  right: 1%;
  z-index: 99;
  background: transparent !important;
  border: 1px solid #1677ff !important;
  color: blue;

  &:hover {
    background: #1677ff !important;
    border-color: #1677ff !important;
    color: #fff !important;
  }

  .anticon {
    color: inherit;
  }
`;

export const StyledRate = styled(Rate)`
  color: #ffa500;

  .ant-rate-star-first,
  .ant-rate-star-second {
    color: rgb(94 89 89 / 25%);
  }
`;
